import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const { REACT_APP_API_KEY, REACT_APP_API_HOSPITAL_KEY } = process.env || {};

const useGetNotifications = () => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [isNotificationsLoading, setIsNotificationsLoading] = useState(false);

  const getNotifications = useCallback(async () => {
    setIsNotificationsLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      const res = await axios.get(
        `/api/v1/chat/broadcast`,
        {
          params: {},
          headers: {
            Authorization: `Bearer ${token}`,
            "ngrok-skip-browser-warning": "hgs",
          },
        }
      );
      setNotifications(res.data?.reverse());
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      if (!error.response) {
        toast.error("Oops, something went wrong");
      } else {
        const messageContent = Array.isArray(errorMessage) ? (
          <ul className="ms-2 list-disc">
            {errorMessage.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        ) : (
          errorMessage || "An unknown error occurred"
        );
        toast.error(messageContent);
        if (error.response?.data?.statusCode === 401) {
          localStorage.removeItem("authToken");
          setTimeout(() => {
            navigate("/");
          }, 1000);
        }
      }
    } finally {
      setIsNotificationsLoading(false);
    }
  }, [navigate]);

  const getOnlineNotifications = useCallback(async () => {
    setIsNotificationsLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      const res = await axios.get(
        `/api/v1/chat/broadcast`,
        {
          params: {},
          headers: {
            Authorization: `Bearer ${token}`,
            "ngrok-skip-browser-warning": "hgs",
          },
        }
      );
      setNotifications(res.data?.reverse());
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      if (!error.response) {
        getNotifications();
        // toast.error("Oops, something went wrong");
      } else {
        const messageContent = Array.isArray(errorMessage) ? (
          <ul className="ms-2 list-disc">
            {errorMessage.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        ) : (
          errorMessage || "An unknown error occurred"
        );
        toast.error(messageContent);
        if (error.response?.data?.statusCode === 401) {
          localStorage.removeItem("authToken");
          setTimeout(() => {
            navigate("/");
          }, 1000);
        }
      }
    } finally {
      setIsNotificationsLoading(false);
    }
  }, [navigate, getNotifications]);

  useEffect(() => {
    getOnlineNotifications();
  }, [getOnlineNotifications]);

  return {
    isNotificationsLoading,
    notifications,
    getNotifications,
  };
};

export default useGetNotifications;
